import React from 'react';

const IconPaper = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 2.87158C3.93003 2.87158 2.25 4.54604 2.25 6.61821V16.6224C2.25 19.2459 4.37685 21.3716 7 21.3716H19C20.5192 21.3716 21.75 20.1408 21.75 18.6216V14.6213C21.75 12.5501 20.071 10.8716 18 10.8716H17.75V6.6207C17.75 4.54934 16.0708 2.87158 14 2.87158H6ZM16.25 11.6216V6.6207C16.25 5.37834 15.2429 4.37158 14 4.37158H6C4.75626 4.37158 3.75 5.37667 3.75 6.61821V16.6224C3.75 18.4171 5.20488 19.8716 7 19.8716H16.5497C16.3581 19.4966 16.25 19.0717 16.25 18.6216V11.6216ZM19 19.8716C19.6908 19.8716 20.25 19.3124 20.25 18.6216V14.6213C20.25 13.3787 19.2427 12.3716 18 12.3716H17.75V18.6216C17.75 19.3124 18.3092 19.8716 19 19.8716ZM6.25 7.62158C6.25 7.20737 6.58579 6.87158 7 6.87158H13C13.4142 6.87158 13.75 7.20737 13.75 7.62158C13.75 8.0358 13.4142 8.37158 13 8.37158H7C6.58579 8.37158 6.25 8.0358 6.25 7.62158ZM7 10.7416C6.58579 10.7416 6.25 11.0774 6.25 11.4916C6.25 11.9058 6.58579 12.2416 7 12.2416H13C13.4142 12.2416 13.75 11.9058 13.75 11.4916C13.75 11.0774 13.4142 10.7416 13 10.7416H7ZM6.25 15.6816C6.25 15.2674 6.58579 14.9316 7 14.9316H10C10.4142 14.9316 10.75 15.2674 10.75 15.6816C10.75 16.0959 10.4142 16.4316 10 16.4316H7C6.58579 16.4316 6.25 16.0959 6.25 15.6816Z"
        fill="#8594A3"
      />
    </svg>
  );
};

export default IconPaper;
